var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 10.1363L2.66675 12.595C2.66675 12.9676 2.80722 13.325 3.05727 13.5885C3.30732 13.852 3.64646 14 4.00008 14H12.0001C12.3537 14 12.6928 13.852 12.9429 13.5885C13.1929 13.325 13.3334 12.9676 13.3334 12.595V10.1363M8.00082 2V9.96164M8.00082 9.96164L11.0484 6.91953M8.00082 9.96164L4.95321 6.91953",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload02);
export default __webpack_public_path__ + "static/media/download-02.fe6989c6e18250865093f42845e78b22.svg";
export { ForwardRef as ReactComponent };